import { useDeleteEntityTemplateDialog } from "./DeleteEntityTemplateDialog.hooks.ts";
import React from "react";
import DotLegalDeleteDialogWrapper from "../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper.tsx";

export interface DeleteEntityTemplateDialogProps {
    entityTemplateId: string;
    entityTemplateName: string;
    onCloseDialog: () => void;
    onDeleteSuccess: () => void;
}

function DeleteEntityTemplateDialog(props: DeleteEntityTemplateDialogProps) {
    const { isDeleting, onDelete } = useDeleteEntityTemplateDialog(props);

    return (
        <DotLegalDeleteDialogWrapper
            open
            inProgress={isDeleting}
            itemForDeletion={props.entityTemplateName}
            onDialogClose={props.onCloseDialog}
            onOkClick={() => onDelete()}
        />
    );
}

export default DeleteEntityTemplateDialog;
